var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: _vm.sectionTitle + " - " + _vm.titleAdd },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function() {
              return [
                _c("Button", {
                  attrs: { variant: "primary", label: "Add Content" },
                  on: {
                    clicked: function($event) {
                      _vm.showModal = true
                    }
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.data.length > 0
                  ? _c(
                      "el-table-draggable",
                      {
                        attrs: { handle: ".handle-move" },
                        on: { sort: _vm.onSort }
                      },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.data,
                              "row-key": "id",
                              "show-header": true
                            }
                          },
                          [
                            _c(
                              "el-table-column",
                              {
                                key: "handle",
                                attrs: {
                                  label: "",
                                  align: "left",
                                  width: "100px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "static inline-block text-center container-action handle-move",
                                    staticStyle: { cursor: "move" }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { size: "2x", icon: ["fa", "th"] }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.sectionType === "song"
                              ? _c("el-table-column", {
                                  attrs: {
                                    label: "Title",
                                    align: "left",
                                    prop: "title"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.sectionType === "playlist"
                              ? _c("el-table-column", {
                                  attrs: {
                                    label: "Playlist Title",
                                    align: "left",
                                    prop: "title"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.sectionType === "song"
                              ? _c("el-table-column", {
                                  attrs: {
                                    label: "Artist Name",
                                    align: "left",
                                    prop: "name"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.sectionType === "album"
                              ? _c("el-table-column", {
                                  attrs: {
                                    label: "Album Name",
                                    align: "left",
                                    prop: "name"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.sectionType === "artist"
                              ? _c("el-table-column", {
                                  attrs: {
                                    label: "Artist Name",
                                    align: "left",
                                    prop: "name"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "Actions", align: "right" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "static inline-block text-left container-action"
                                          },
                                          [
                                            _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Delete",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deleteContent(
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: [
                                                          "fa",
                                                          "trash-alt"
                                                        ]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                528068336
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.data.length === 0
                  ? _c("div", { staticClass: "flex justify-center py-6" }, [
                      _vm._v(
                        "\n        No content added. Please add a content to continue\n      "
                      )
                    ])
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "addSong",
          attrs: {
            size: "large",
            isShowingModal: _vm.showModal,
            title: "Add " + _vm.titleAdd,
            labelSubmit: "Submit"
          },
          on: {
            toggleModal: function($event) {
              _vm.showModal = !_vm.showModal
            },
            save: function($event) {
              return _vm.submitAddContent()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _vm.sectionType === "song"
                ? _c("SearchSong", {
                    ref: "addSongContent",
                    attrs: {
                      "toggle-reset": _vm.showModal,
                      "taken-song": _vm.data
                    },
                    on: {
                      "on-remove-song": _vm.onRemoveFromSearch,
                      "on-submit-song": _vm.addContentBulk
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.sectionType === "album"
                ? _c("SearchAlbum", {
                    ref: "addAlbumContent",
                    attrs: {
                      "toggle-reset": _vm.showModal,
                      "taken-album": _vm.data
                    },
                    on: {
                      "on-remove-album": _vm.onRemoveFromSearch,
                      "on-submit-album": _vm.addContentBulk
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.sectionType === "artist"
                ? _c("SearchArtist", {
                    ref: "addArtistContent",
                    attrs: {
                      "toggle-reset": _vm.showModal,
                      "taken-artist": _vm.data
                    },
                    on: {
                      "on-remove-artist": _vm.onRemoveFromSearch,
                      "on-submit-artist": _vm.addContentBulk
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.sectionType === "playlist"
                ? _c("SearchPlaylist", {
                    ref: "addPlaylistContent",
                    attrs: {
                      "toggle-reset": _vm.showModal,
                      "taken-playlist": _vm.data
                    },
                    on: {
                      "on-remove-playlist": _vm.onRemoveFromSearch,
                      "on-submit-playlist": _vm.addContentBulk
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4eaed571", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eaed571","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AppSetting/HomeSectionDetail.vue
// module id = null
// module chunks = 